import { render, staticRenderFns } from "./FichaPostulante1.vue?vue&type=template&id=3a142243&scoped=true&"
import script from "./FichaPostulante1.vue?vue&type=script&lang=js&"
export * from "./FichaPostulante1.vue?vue&type=script&lang=js&"
import style0 from "./FichaPostulante1.vue?vue&type=style&index=0&id=3a142243&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a142243",
  null
  
)

export default component.exports